export default {
    methods: {
        validPostcode: function (value, regexStr) {
            var re = new RegExp(regexStr, 'i');
            return re.test(value) || !regexStr ? '' : "Invalid post code";
        },
    }
}
